'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getPresentation = exports.getIcon = exports.getImage = undefined;

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _media = require('./media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var getImage = exports.getImage = function getImage(stateString, props) {
	return (0, _magicVirtualElement2.default)(_media.Image, { 'class': props.styleClasses.Image, source: props['image' + stateString], 'data-style-attr': 'Image' });
};

var getIcon = exports.getIcon = function getIcon(stateString, props) {
	try {
		var iconStateString = 'icon' + stateString;
		var parsedIcon = props['' + iconStateString] ? JSON.parse(props['' + iconStateString]) : { x: {} };
		var styles = {
			color: props[iconStateString + 'Color'],
			fontSize: props[iconStateString + 'Size'] && props[iconStateString + 'Size'].replace(',', '.') || ''
		};

		return (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': props.styleClasses.Icon, 'data-style-attr': 'Icon', style: !props.styleClasses.Icon && styles },
			(0, _magicVirtualElement2.default)('i', { key: '' + parsedIcon.x.name + parsedIcon.prefix, 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name })
		);
	} catch (err) {
		console.error(err);

		return (0, _magicVirtualElement2.default)('noscript', null);
	}
};

var getPresentation = exports.getPresentation = function getPresentation(stateString, props) {
	if (!props.type) {
		if (!props.iconOpen && !props.iconClosed) {
			return props.label;
		}

		return getIcon(stateString, props);
	}

	switch (props.type) {
		case 'icon':
			{
				return getIcon(stateString, props);
			}
		case 'image':
			{
				return getImage(stateString, props);
			}
		case 'text':
		default:
			{
				return props.label;
			}
	}
};